import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ce7bd58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo-image" }),
  /*#__PURE__*/_createElementVNode("h1", { class: "logo-text" }, "gence.io")
], -1))
const _hoisted_3 = { class: "something-container pt-4" }
const _hoisted_4 = { class: "something" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"features mb-6\" data-v-4ce7bd58><div class=\"feature\" data-v-4ce7bd58><div class=\"image text-glow\" data-v-4ce7bd58>∫</div><span class=\"title\" data-v-4ce7bd58>Technical Domains</span><span class=\"description\" data-v-4ce7bd58> Technical writings written only by vetted industry experts </span></div><div class=\"feature\" data-v-4ce7bd58><div class=\"image text-glow\" data-v-4ce7bd58>{ }</div><span class=\"title\" data-v-4ce7bd58>Targeted Features</span><span class=\"description\" data-v-4ce7bd58> Features focused on understanding, ease of use, and sophisticated tooling </span></div><div class=\"feature\" data-v-4ce7bd58><div class=\"image times text-glow\" data-v-4ce7bd58>☼</div><span class=\"title\" data-v-4ce7bd58>Growing Community</span><span class=\"description\" data-v-4ce7bd58> A growing community where you can make a difference </span></div><div class=\"feature\" data-v-4ce7bd58><div class=\"image text-glow\" data-v-4ce7bd58>&gt;</div><span class=\"title\" data-v-4ce7bd58>Beautiful Editor</span><span class=\"description\" data-v-4ce7bd58> An easy to use editor, to maximize your productivity </span></div></div>", 1)
const _hoisted_6 = { class: "call-to-action mb-6" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "emphasize mb-4" }, "Give Rise To Something New", -1))
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Explore ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Start Writing ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/explore",
              class: "no-link button"
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/join",
              class: "no-link button"
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}